import { render, staticRenderFns } from "./yypz.vue?vue&type=template&id=28bd0b6a&scoped=true"
import script from "./yypz.vue?vue&type=script&lang=js"
export * from "./yypz.vue?vue&type=script&lang=js"
import style0 from "./yypz.vue?vue&type=style&index=0&id=28bd0b6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd0b6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28bd0b6a')) {
      api.createRecord('28bd0b6a', component.options)
    } else {
      api.reload('28bd0b6a', component.options)
    }
    module.hot.accept("./yypz.vue?vue&type=template&id=28bd0b6a&scoped=true", function () {
      api.rerender('28bd0b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/sysConfig/yypz.vue"
export default component.exports